import React, { useEffect } from "react";
import PropTypes from "prop-types";
import withStyles from "@material-ui/core/styles/withStyles";
import Picker from "../Picker";
import { parseDateTimeToString } from "./utils"
import moment from "moment";
import "moment-timezone"
import "./style.css"
import { ConsoleLogger } from "@aws-amplify/core";

const createClasses = (obj, property, nameAddition = "") =>
  Object.keys(obj).reduce(
    (a, c) => ({ ...a, [`${nameAddition}${c}`]: { [property]: obj[c] } }),
    {}
  );

const InputComponent = ({
  className,
  classes,
  color,
  font_weight,
  size,
  textarea,
  onChange,
  value,
  onError,
  disabled,
  ...props
}) => {

  const [startDateTime, setStartDateTime] = React.useState();
  const [endDateTime, setEndDateTime] = React.useState();

  useEffect(() => {
    if (value.startAt && value.endAt) {
      setStartDateTime(value.startAt);
      setEndDateTime(value.endAt);
    }
  }, [value])

  useEffect(() => {
    if (startDateTime && setEndDateTime) {
      onChange({
        startAt: startDateTime,
        endAt: endDateTime
      });
    }
  }, [startDateTime, endDateTime])

  const isValid = (startDateTime, endDateTime) => {
    let timezoneString = props.timezoneString
    // let now = moment.tz(new Date().toISOString(), timezone);
    let now = moment(new Date().toISOString()).tz(timezoneString)

    if (startDateTime.isBefore(now)) {
      if (typeof onError === "function")
        onError("Start date time cannot be in past")
      return false
    }
    if (endDateTime.isBefore(startDateTime) || endDateTime.isSame(startDateTime)) {
      if (typeof onError === "function")
        onError("End time cannot be less then or same as start time")
      return false
    }
    return true
  }


  const onDateChange = (data) => {
    let start = moment(data);
    if (start == "Invalid Date") return
    start.set({
      hour: startDateTime.hour(),
      minute: startDateTime.minute(),
    })
    let end = moment(data);
    end.set({
      hour: endDateTime.hour(),
      minute: endDateTime.minute(),
    })
    if (isValid(start, end)) {
      setStartDateTime(start);
      setEndDateTime(end);
    }
  }

  const onStartTimeChange = (data) => {
    if (data == "Invalid Date") return
    let start = moment(startDateTime);
    start.set({
      hour: data.hour(),
      minute: data.minute(),
    })

    let end = moment(startDateTime)
    end.set({
      hour: start.hour() + 1,
      minute: start.minute(),
    })
    end.date(start.date())
    if (isValid(start, end)) {
      setStartDateTime(start)
      setEndDateTime(end)
    }
  }

  const onOnEndTimeChange = (data) => {
    if (data == "Invalid Date") return
    let end = moment(startDateTime)
    end.set({
      hour: data.hour(),
      minute: data.minute(),
    })
    if (isValid(startDateTime, end)) {
      setEndDateTime(end)
    }
  }

  const valueStr = startDateTime && endDateTime ? parseDateTimeToString(startDateTime, endDateTime) : ""

  if (!value || !startDateTime || !endDateTime) return null
  return (
    <div className={classes.pickerContainer} >
      <div className={classes.dateContainer}>
        <Picker id="hyly-date" onFocus={props.onFocus} onBlur={props.onBlur} className={classes.input} type="date" defaultValue={startDateTime} value={valueStr ? valueStr.split("*")[0] : ""} handleChange={onDateChange} disabled={disabled} />
      </div>
      <div className={classes.timeContainer}>
        <Picker id="hyly-time" onFocus={props.onFocus} onBlur={props.onBlur} className={classes.input} type="time" defaultValue={startDateTime} value={valueStr ? valueStr.split("*")[1].split(" - ")[0] : ""} handleChange={onStartTimeChange} disabled={disabled} />
      </div>
      <span className={`${classes.input} ${disabled ? classes.disabled : ""}`} style={{ width: "auto" }}> - </span>
      <div className={classes.timeContainer}>
        <Picker id="hyly-time" onFocus={props.onFocus} onBlur={props.onBlur} className={classes.input} type="time" defaultValue={endDateTime} value={valueStr ? valueStr.split("*")[1].split(" - ")[1] : ""} handleChange={onOnEndTimeChange} disabled={disabled} />
      </div>
      <div className={`${disabled ? classes.disabled : ""}`}>
        , {props.timezoneAbbr}
      </div>
    </div>
  )
}

InputComponent.propTypes = {
  color: PropTypes.oneOf([
    "white",
    "black",
    "darkBlack",
    "deepGrey",
    "mediumGrey",
    "hylyBlue",
    "red"
  ]),
  size: PropTypes.oneOf([
    "xs",
    "sm",
    "md",
    "lg",
    "xl",
  ]),
  font_weight: function (props, propName, componentName) {
    if (
      !/\d+/.test(props[propName]) ||
      +props[propName] > 600 ||
      +props[propName] < 200
    ) {
      return new Error(
        "Invalid prop `" +
        propName +
        "` supplied to" +
        " `" +
        componentName +
        "`. Expected a number in range between 200 - 600."
      );
    }
  }
};

InputComponent.defaultProps = {
  color: "darkBlack",
  font_weight: "400"
};

export default withStyles((styles) => ({
  ...createClasses(
    {
      white: "#fff",
      black: "#000",
      darkBlack: "#333",
      deepGrey: "#4F4F4F",
      mediumGrey: "#CCC",
      hylyBlue: "#26bbed",
      red: "#FF5151"
    },
    "color",
    "color_"
  ),
  ...createClasses(
    {
      "200": 200,
      "300": 300,
      "400": 400,
      "500": 500,
      "600": 600
    },
    "fontWeight",
    "fontWeight_"
  ),
  ...createClasses(
    {
      "xs": 10,
      "sm": 12,
      "md": 14,
      "lg": 16,
      "xl": 18
    },
    "fontSize",
    "fontSize_"
  ),
  pickerContainer: {
    fontSize: 32,
    display: "flex",
    justifyContent: "center",
    fontWeight: "600"

  },
  input: {
    fontSize: 32,
    width: "100%",
    fontWeight: "600"
  },
  dateContainer: {
    width: 200,
    textAlign: "left !important"
  },
  timeContainer: {
    width: 150,
    textAlign: "left !important"
  },
  disabled: {
    color: "#626060"
  }
}))(InputComponent);
